<template>
    <div :class="eventClass">
        <div class="image-cell">
            <img v-if="hasImage" v-bind:src="item.image" v-bind:title="item.name"
            style="object-fit: cover;
            height: 100%;
            text-indent: -9999px;"/>
        </div>
        <div class="item-cell">
            <div class="item-name"><strong>{{item.name}}</strong></div>
            <expandable-text class="description"
            :text="item.description"></expandable-text>
        </div>
        <div class="last-cell">
            <div class="last-cell-price-duration">
                <div class="price-duration">
                    <div v-if="price"><strong>{{parseFloat(price) | toCurrency}}</strong></div>
                </div>
                <div class="select button-column">
                    <button v-if="showSelectButton"
                    class="btn-step-select"
                    :value="item.id"
                    v-on:click="$emit('filled-out', item.id)"
                    >Select</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ExpandableText from '../ExpandableText';

  export default {
    props: {
      item: {},
      value: '',
      allowSelect: true,
      teamMember: ''
    },
    computed: {
        hasImage(){
            return this.item.image;
        },
        showSelectButton() {
            return this.allowSelect;
        },
        getValueId()  {
            return this.value ? this.value.id : '';
        },
        eventClass() {
            return {
                "event-row": true,
                "step-fields-list-box-item": true,
                "selected": this.getValueId==this.item.id
            };
        },
        duration() {
            let duration = [];
            if (this.item.duration.h) {
                duration.push(this.item.duration.h + 'h');
            }
            if (this.item.duration.m) {
                duration.push(this.item.duration.m + 'm');
            }
            return duration.join(' ');
        },
        price() {
            let price = this.teamMember && this.teamMember.price ? this.teamMember.price : this.item.basePrice;
            return price;
        }
    },
    components: {
        ExpandableText
    }
  };
</script>

<style>
.event-row .description {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #7c7e82;
}
.image-cell {
    display: flex;
    -moz-box-pack: center;
    justify-content: center;
    -moz-box-align: center;
    align-items: center;
    background: rgb(238, 238, 238) none repeat scroll 0% 0%;
    color: rgb(187, 187, 187);
    border-radius: 4px;
    overflow: hidden;
    width: 60px;
    height: 60px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px inset;
}
.item-cell {
    box-sizing: border-box;
    margin: 0px;
    min-width: 0px;
}
.last-cell {
	box-sizing: border-box;
	margin: 0px;
	min-width: 0px;
	display: flex;
	-moz-box-align: top;
	align-items: top;
}
.last-cell-price-duration {
	box-sizing: border-box;
	margin: 0px 12px 0px 0px;
	min-width: 0px;
	text-align: right;
}
.event-row {
	box-sizing: border-box;
	min-width: 0px;
	display: grid;
	gap: 12px;
	grid-template-columns: repeat(3, 1fr);
	width: 100%;
}
.last-cell-button {
    display: block
}
@media only screen and (min-width: 30em) {
  .event-row {
  	grid-template-columns: max-content auto max-content;
  }
  .last-cell-button {
      display: inline-block;
  }
}
</style>
